import { supabase } from './supabase';

type AppErrorSource = 'frontend' | 'worker' | 'file_fetch' | 'supabase_rpc';

export interface LogAppErrorParams {
  source: AppErrorSource;
  statusCode?: number | null;
  path: string;
  method?: string | null;
  context?: string | null;
  message?: string | null;
}

export const logAppError = async (params: LogAppErrorParams): Promise<void> => {
  try {
    await supabase.rpc('log_app_error', {
      p_source: params.source,
      p_status_code: params.statusCode || null,
      p_path: params.path,
      p_method: params.method || null,
      p_context: params.context || null,
      p_message: params.message || null,
    });
  } catch (err) {
    // Fail silently to not disrupt the user if logging itself fails
    console.warn('Failed to log app error to Supabase:', err);
  }
};
